import { AxiosResponseType } from '../../types/axiosTypes';
import api from '../axios';
import { fetchAuthSession } from '@aws-amplify/core';

export const getGroupedReports = async (
  currentWeek: string,
  layoutId: string
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();
  if (!tokens) {
    throw new Error('Error fetching grouped reports: No tokens found');
  }

  const idToken = tokens.idToken?.toString();

  const res = await api.post<AxiosResponseType>(
    `/reports/getGroupedReports`,
    { currentWeek, reportLayoutId: layoutId },
    {
      headers: {
        Authorization: idToken,
      },
    }
  );

  return res.data;
};

export const submitReport = async (
  formData: FormData
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();
  if (!tokens) {
    throw new Error('Error during submission: No tokens found');
  }

  const idToken = tokens.idToken?.toString();

  const res = await api.post<AxiosResponseType>(
    `/reports/submitReport`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data', // Required for file uploads
        Authorization: idToken,
      },
    }
  );

  return res.data;
};

export const createReportLayout = async (
  payload: any
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();
  if (tokens) {
    const idToken = tokens.idToken?.toString();

    const res = await api.post<AxiosResponseType>(`/reports/createLayout`, {
      token: idToken,
      payload,
    });
    return res.data;
  } else {
    throw new Error('User Not found');
  }
};

export async function createReportLayoutMultipart(form: FormData) {
  const { tokens } = await fetchAuthSession();
  if (!tokens) throw new Error('User Not found');
  const idToken = tokens.idToken?.toString();

  // IMPORTANT: don't set Content-Type; browser sets boundary
  const res = await api.post('/reports/createLayoutMultipart', form, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: idToken,
    },
  });
  return res.data;
}

export const getReportCategories =
  async (): Promise<AxiosResponseType | null> => {
    const { tokens } = await fetchAuthSession();
    if (tokens) {
      const idToken = tokens.idToken?.toString();

      const res = await api.post<AxiosResponseType>(
        `/reports/getReportCategories`,
        {
          token: idToken,
        }
      );
      return res.data;
    } else {
      throw new Error('User Not found');
    }
  };

export const invalidateLayout = async (
  layoutId: string
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();
  if (tokens) {
    const idToken = tokens.idToken?.toString();

    const res = await api.post<AxiosResponseType>(`/reports/invalidateLayout`, {
      token: idToken,
      layoutId,
    });
    return res.data;
  } else {
    throw new Error('User Not found');
  }
};
